import {useEffect, useRef, useState} from "react";
import {RectBtn} from "../../components/General";
import {BsCircle, BsRecordCircle} from "react-icons/bs";
import {AiFillEdit, AiTwotoneSave} from "react-icons/ai";
import {MdDeleteForever} from "react-icons/md";

import {useSelector} from "react-redux";
import {
  selectBuilding,
  selectDevice,
  selectRoom,
  selectSensor,
} from "../../features/store";
import {AMMONIA, HAND_TOWEL, PAPER_ROLL, SOAP} from "../../configs/global";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import {IoIosAddCircleOutline} from "react-icons/io";

export const Step1 = ({
  nextStep,
  option,
  setOption,
  setNewBuilding,
  newBuilding,
  selectedBuilding,
  setSelectedBuilding,
}) => {
  const buildings = useSelector(selectBuilding);
  const [selectBuildingError, setSelectBuildingError] = useState("");
  const [newBuildingIdError, setNewBuildingIdError] = useState("");
  const [newBuildingNameError, setNewBuildingNameError] = useState("");

  function finishStep() {
    setSelectBuildingError("");
    setNewBuildingIdError("");
    setNewBuildingNameError("");
    if (option === 0) {
      if (selectedBuilding.buildingName === "") {
        setSelectBuildingError("Must select a building");

        return;
      }
    } else {
      if (newBuilding.buildingId === "") {
        setNewBuildingIdError("Building ID cannot be empty");

        return;
      }
      if (newBuilding.buildingName === "") {
        setNewBuildingNameError("Building name cannot be empty");
        return;
      }

      if (buildings[newBuilding.buildingId]) {
        setNewBuildingIdError("Building ID must be unique");

        return;
      }
      for (let bid of Object.keys(buildings)) {
        if (buildings[bid].buildingName === newBuilding.buildingName) {
          setNewBuildingNameError("Building name must be unique");

          return;
        }
      }
    }
    nextStep();
  }
  return (
    <div className="step1 stepPage">
      <div
        className="selection"
        style={option === 0 ? {opacity: "1"} : {opacity: "0.5"}}
      >
        <div
          onClick={() => {
            setOption(0);
          }}
          className="selectBtn"
        >
          {option === 0 ? <BsRecordCircle /> : <BsCircle />}
        </div>
        <div
          style={
            option === 0 ? {pointerEvents: "auto"} : {pointerEvents: "none"}
          }
        >
          <FormControl sx={{width: 180}} error={selectBuildingError !== ""}>
            <InputLabel id="select-building">Select Building</InputLabel>

            <Select
              id="select-building"
              value={selectedBuilding.buildingId}
              onChange={(e) => {
                setSelectedBuilding(buildings[e.target.value]);
              }}
              labelId="select-building"
              label="select-building"
            >
              {Object.keys(buildings).map((bid, i) => (
                <MenuItem value={bid} key={bid}>
                  {buildings[bid].buildingName}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{selectBuildingError}</FormHelperText>
          </FormControl>
        </div>
        <p>Or</p>
      </div>

      <div
        className="selection verticle"
        style={option === 1 ? {opacity: "1"} : {opacity: "0.5"}}
      >
        <div className="firstRow">
          <div
            onClick={() => {
              setOption(1);
            }}
            className="selectBtn"
          >
            {option === 1 ? <BsRecordCircle /> : <BsCircle />}
          </div>
          <p>Add New Building</p>
        </div>

        <div
          className="create-building-fields"
          style={
            option === 1 ? {pointerEvents: "auto"} : {pointerEvents: "none"}
          }
        >
          <TextField
            placeholder="Building ID"
            onChange={(event) => {
              let obj = {...newBuilding};
              obj.buildingId = event.target.value;

              setNewBuilding(obj);
            }}
            value={newBuilding.buildingId}
            inputProps={{maxLength: 20}}
            label="Building ID"
            error={newBuildingIdError !== ""}
            helperText={newBuildingIdError}
          ></TextField>
          <TextField
            placeholder="Building Name"
            onChange={(event) => {
              let obj = {...newBuilding};
              obj.buildingName = event.target.value;
              setNewBuilding(obj);
            }}
            value={newBuilding.buildingName}
            inputProps={{maxLength: 30}}
            label="Building Name"
            error={newBuildingNameError !== ""}
            helperText={newBuildingNameError}
          ></TextField>
        </div>
      </div>

      <div className="step1-btn-wrapper">
        <RectBtn onClick={finishStep}> Next </RectBtn>
      </div>
    </div>
  );
};

export const Step2 = ({nextStep, prevStep, newRoom, setNewRoom}) => {
  const rooms = useSelector(selectRoom);
  const [roomIdError, setRoomIdError] = useState("");
  const [roomNameError, setRoomNameError] = useState("");
  const [roomFloorError, setRoomFloorError] = useState("");

  function finishStep() {
    setRoomIdError("");
    setRoomNameError("");
    setRoomFloorError("");
    if (newRoom.roomId === "") {
      setRoomIdError("Room ID cannot be empty");
      return;
    }
    if (newRoom.roomName === "") {
      setRoomNameError("Room name cannot be empty");
      return;
    }
    if (newRoom.floor === "") {
      setRoomFloorError("Floor cannot be empty");
      return;
    }
    for (let rid of Object.keys(rooms)) {
      if (rid === newRoom.roomId) {
        setRoomIdError("Room ID must be unique");

        return;
      }
      if (rooms[rid].roomName === newRoom.roomName) {
        setRoomNameError("Room Name must must be unique");
        return;
      }
    }
    nextStep();
  }
  return (
    <div className="step2 stepPage">
      <div className="fields">
        <TextField
          label="Room ID"
          placeholder="Room ID"
          onChange={(e) => {
            setNewRoom({...newRoom, roomId: e.target.value});
          }}
          value={newRoom.roomId}
          inputProps={{maxLength: 20}}
          error={roomIdError !== ""}
          helperText={roomIdError}
        />

        <TextField
          label="Room Name"
          placeholder="Room Name"
          onChange={(e) => {
            setNewRoom({...newRoom, roomName: e.target.value});
          }}
          inputProps={{maxLength: 30}}
          value={newRoom.roomName}
          error={roomNameError !== ""}
          helperText={roomNameError}
        />

        <TextField
          label="Floor"
          placeholder="Floor"
          onChange={(e) => {
            setNewRoom({...newRoom, floor: e.target.value});
          }}
          value={newRoom.floor}
          inputProps={{maxLength: 20}}
          error={roomFloorError !== ""}
          helperText={roomFloorError}
        />
      </div>

      <div className="step-btn-row">
        <RectBtn onClick={finishStep}> Next </RectBtn>
        <span onClick={() => prevStep()}> Back </span>
      </div>
    </div>
  );
};

export const Step3 = ({nextStep, prevStep, newSensors, setNewSensors}) => {
  const sensors = useSelector(selectSensor);
  const [errorMsg, setErrorMsg] = useState("");
  const [uid, setUid] = useState(0);
  function finishStep() {
    setErrorMsg("");
    for (let sensor of newSensors) {
      if (
        sensor.sensorId === "id" ||
        sensor.sensorName === "name" ||
        sensor.type === "type"
      ) {
        setErrorMsg("Fields cannot be kept default");

        return;
      }
      if (
        sensor.sensorId === "" ||
        sensor.sensorName === "" ||
        sensor.type === ""
      ) {
        setErrorMsg("Fields cannot be empty");
        return;
      }
      if (sensors[sensor.sensorId]) {
        setErrorMsg("Sensor ID must be unique");
        return;
      }
      for (let s of Object.keys(sensors)) {
        if (sensors[s].sensorName === sensor.sensorName) {
          setErrorMsg("Sensor Name must be unique");
          return;
        }
      }
      // check for duplicate
      let idList = newSensors.map((e) => e.sensorId);
      let nameList = newSensors.map((e) => e.sensorName);
      if (
        idList.length !== new Set(idList).size ||
        nameList.length !== new Set(nameList).size
      ) {
        setErrorMsg("Cannot contain duplicated entries");
        return;
      }
    }
    nextStep();
  }

  function addSensor() {
    let temp = [...newSensors];
    if (temp.length === 0) {
      temp.push({uid: uid, sensorId: "id", sensorName: "name", type: "type"});
    } else {
      let last = temp[temp.length - 1];
      let assumedSid = last.sensorId;
      if (!isNaN(last.sensorId)) {
        assumedSid = (parseInt(last.sensorId) + 1).toString();
      }
      temp.push({
        uid: uid,
        sensorId: assumedSid,
        sensorName: last.sensorName,
        type: last.type,
      });
    }
    setUid(uid + 1);

    setNewSensors(temp);
  }
  return (
    <div className="step3 stepPage">
      <div className="step3-card">
        <div className="tableWrapper">
          <table className="sensorTable">
            <thead>
              <tr>
                {["Sensor Id", "Name", "Type"].map((element, index) => {
                  return (
                    <th key={index + "headerEntry"} colSpan={1}>
                      {element}
                    </th>
                  );
                })}
                <th colSpan={2}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {newSensors.length <= 0 ? (
                <tr>
                  <td colSpan={5}>
                    <p className="no-sensor">No Sensors</p>
                  </td>
                </tr>
              ) : (
                newSensors.map((element, index) => {
                  return (
                    <AddSensorRow
                      key={element.uid + "tableData"}
                      rowData={element}
                      index={index}
                      sensors={newSensors}
                      setSensors={setNewSensors}
                      setErrorMsg={setErrorMsg}
                    />
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        <div className="add-sensor-btn-wrapper">
          <RectBtn
            onClick={() => {
              setErrorMsg("");
              addSensor();
            }}
          >
            <div className="add-sensor-btn-row">
              <IoIosAddCircleOutline className="icon" />
              <p>Add Sensor</p>
            </div>
          </RectBtn>
        </div>

        <div className="error-msg">{errorMsg}</div>
      </div>

      <div className="step-btn-row">
        <RectBtn onClick={finishStep}> Next </RectBtn>
        <span
          onClick={() => {
            prevStep();
          }}
        >
          Back
        </span>
      </div>
    </div>
  );
};

export const StepAddDevice = ({
  nextStep,
  prevStep,
  newDevices,
  setNewDevices,
  nanoOption,
  setNanoOption,
  selectedNano,
  setSelectedNano,
}) => {
  const devices = useSelector(selectDevice);
  const [feedbackId, setFeedbackId] = useState("");
  const [feedbackError, setFeedbackError] = useState("");
  const [peopleCountId, setPeopleCountId] = useState("");
  const [peopleCountError, setPeopleCountError] = useState("");
  const [selectNanoError, setSelectNanoError] = useState("");
  const [newNanoError, setNewNanoError] = useState("");
  const [nanoId, setNanoId] = useState("");

  useEffect(() => {
    setFeedbackId(newDevices.f.slice(1));
    setPeopleCountId(newDevices.p.slice(1));
  }, [newDevices]);
  function finishStep() {
    setFeedbackError("");
    setPeopleCountError("");
    setNewNanoError("");
    setSelectNanoError("");

    if (feedbackId === "") {
      setFeedbackError("This field cannot be empty");
      return;
    }
    if (peopleCountId === "") {
      setPeopleCountError("This field cannot be empty");
      return;
    }
    if (devices["F" + feedbackId]) {
      setFeedbackError("Feedback ID must be unique");
      return;
    }
    if (devices["P" + peopleCountId]) {
      setPeopleCountError("Footfall ID must be unique");
      return;
    }

    let obj = {
      f: "F" + feedbackId,
      p: "P" + peopleCountId,
    };
    if (nanoOption === 1) {
      if (nanoId === "") {
        setNewNanoError("This field cannot be empty");
        return;
      }
      if (devices["N" + nanoId]) {
        setNewNanoError("Nano ID must be unique");
        return;
      }
      obj["n"] = "N" + nanoId;
    } else if (nanoOption === 0) {
      if (selectedNano === "") {
        setSelectNanoError("This field cannot be empty");
        return;
      }
      delete obj["n"];
    }

    setNewDevices(obj);
    nextStep();
  }
  return (
    <div className="step-add-device  stepPage">
      <div className="step-add-device-fields">
        <TextField
          id="standard"
          label="Feedback Panel ID"
          onChange={(e) => {
            if (e.target.value.length < 1) return;
            if (e.target.value[0] !== "F") {
              setFeedbackId(e.target.value[0] + e.target.value.substring(2));
            } else {
              setFeedbackId(e.target.value.substring(1));
            }
          }}
          value={"F" + feedbackId}
          error={feedbackError !== ""}
          helperText={feedbackError}
        />
        <TextField
          id="standard"
          label="Footfall ID"
          onChange={(e) => {
            if (e.target.value.length < 1) return;
            if (e.target.value[0] !== "P") {
              setPeopleCountId(e.target.value[0] + e.target.value.substring(2));
            } else {
              setPeopleCountId(e.target.value.substring(1));
            }
          }}
          value={"P" + peopleCountId}
          error={peopleCountError !== ""}
          helperText={peopleCountError}
        />
      </div>

      <p className="nano-header"> Select or Create Nano</p>
      <div className="nano-fields">
        <div className="nano-option">
          <div
            onClick={() => {
              setNanoOption(0);
              setNewNanoError("");
              setSelectNanoError("");
            }}
            className="selectBtn"
          >
            {nanoOption === 0 ? <BsRecordCircle /> : <BsCircle />}
          </div>

          <FormControl
            sx={{width: 180, height: "100%"}}
            error={selectNanoError !== ""}
            disabled={nanoOption !== 0}
          >
            <InputLabel id="select-nano">Select Nano</InputLabel>

            <Select
              id="select-Nano"
              value={selectedNano}
              onChange={(e) => {
                setSelectedNano(e.target.value);
              }}
              labelId="select-nano"
              label="Select Nano"
            >
              {Object.keys(devices)
                .filter((did) => did.toUpperCase().startsWith("N"))
                .map((did, i) => (
                  <MenuItem value={did} key={did}>
                    {devices[did].deviceId}
                  </MenuItem>
                ))}
            </Select>
            <FormHelperText>{selectNanoError}</FormHelperText>
          </FormControl>

          <p>Or</p>
        </div>
        <div className="nano-option">
          <div
            onClick={() => {
              setNanoOption(1);
              setNewNanoError("");
              setSelectNanoError("");
            }}
            className="selectBtn"
          >
            {nanoOption === 1 ? <BsRecordCircle /> : <BsCircle />}
          </div>

          <TextField
            placeholder="New Nano ID"
            onChange={(e) => {
              if (e.target.value.length < 1) return;
              if (e.target.value[0] !== "N") {
                setNanoId(e.target.value[0] + e.target.value.substring(2));
              } else {
                setNanoId(e.target.value.substring(1));
              }
            }}
            value={"N" + nanoId}
            disabled={nanoOption === 0}
            inputProps={{maxLength: 20}}
            label="New Nano ID"
            sx={{height: "100%"}}
            error={newNanoError !== ""}
            helperText={newNanoError}
          ></TextField>
        </div>
      </div>
      <div className="step-btn-row">
        <RectBtn onClick={finishStep}> Next </RectBtn>
        <span onClick={() => prevStep()}> Back </span>
      </div>
    </div>
  );
};

export const Step4 = ({confirmAddConfig, prevStep}) => {
  return (
    <div className="step4  stepPage">
      <p>A new room is configured successfully.</p>
      <div className="step-btn-row">
        <RectBtn onClick={confirmAddConfig}> Done</RectBtn>
        <span onClick={() => prevStep()}> Back </span>
      </div>
    </div>
  );
};

const AddSensorRow = ({
  sensors, // the sensors this room holds
  setSensors, // modifies sensors of the room
  index,
  setErrorMsg,
}) => {
  // id, name, type fields are initialize as the inserted value
  const [senId, setSenId] = useState(sensors[index].sensorId);
  const [senName, setSenName] = useState(sensors[index].sensorName);
  const [senType, setSenType] = useState(sensors[index].type);
  const [openUpdate, setOpenUpdate] = useState(true);

  const idRef = useRef();
  // whenever field value is updated, update the actual list
  useEffect(() => {
    let temp = [...sensors];
    temp[index].sensorId = senId;
    temp[index].sensorName = senName;
    temp[index].type = senType;
    setSensors(temp);
  }, [senId, senName, senType]);

  useEffect(() => {
    if (index === sensors.length - 1) return;
    setOpenUpdate(false);
  }, [sensors.length]);

  useEffect(() => {
    if (openUpdate) idRef.current.focus();
  }, [openUpdate]);

  return (
    <tr className={openUpdate ? "tr-active" : "tr-inactive"}>
      <td>
        <input
          ref={idRef}
          type="text"
          value={senId}
          onChange={(e) => setSenId(e.target.value)}
          disabled={!openUpdate}
          maxLength={20}
        />
      </td>
      <td>
        <input
          type="text"
          value={senName}
          onChange={(e) => setSenName(e.target.value)}
          disabled={!openUpdate}
          maxLength={30}
        />
      </td>
      <td>
        <select
          name="type"
          id="type"
          onChange={(e) => setSenType(e.target.value)}
          disabled={!openUpdate}
          value={senType}
        >
          <option value="type" disabled hidden>
            Type
          </option>
          <option value={AMMONIA}>Ammonia</option>
          <option value={PAPER_ROLL}>Paper Roll</option>
          <option value={HAND_TOWEL}>Hand Towel</option>
          <option value={SOAP}>Soap</option>
        </select>
      </td>
      <td>
        <div className="icon-btn-in-table-wrapper">
          {!openUpdate ? (
            <AiFillEdit
              className="icon-btn-in-table"
              onClick={() => {
                setErrorMsg("");
                setOpenUpdate(true);
              }}
            ></AiFillEdit>
          ) : (
            <AiTwotoneSave
              className="icon-btn-in-table"
              onClick={() => {
                setErrorMsg("");
                setOpenUpdate(false);
              }}
            />
          )}
        </div>
      </td>
      <td>
        <div className="icon-btn-in-table-wrapper">
          <MdDeleteForever
            className="icon-btn-in-table delete-btn"
            onClick={() => {
              setErrorMsg("");
              let newTableData = [...sensors];
              newTableData.splice(index, 1);
              setSensors(newTableData);
            }}
          ></MdDeleteForever>
        </div>
      </td>
    </tr>
  );
};
